var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    [
      _c(
        "v-container",
        { attrs: { fluid: "", "grid-list-xl": "" } },
        [
          _c(
            "v-tabs",
            { staticClass: "mb-9", attrs: { left: "", color: "transparent" } },
            [
              _c("v-tab", { on: { click: _vm.selectEstadoDispositivo } }, [
                _vm._v("Estado Dispositivos")
              ]),
              _c("v-tab", { on: { click: _vm.selectRanking } }, [
                _vm._v("Ranking Conductores")
              ]),
              _c(
                "v-tab",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: false,
                      expression: "false"
                    }
                  ],
                  on: { click: _vm.selectSellos }
                },
                [_vm._v("Sellos")]
              ),
              _c("v-tab", { on: { click: _vm.selectAlertas } }, [
                _vm._v("Alertas")
              ]),
              _c("v-tab", { on: { click: _vm.selectDetencionNoAutorizada } }, [
                _vm._v("Detención No Autorizada\n      ")
              ])
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.cargando,
                  expression: "cargando"
                }
              ],
              staticStyle: {
                width: "100%",
                display: "flex",
                "align-items": "center",
                "justify-content": "center"
              }
            },
            [
              _c(
                "h3",
                {
                  staticStyle: { "font-size": "1.6vmin", "font-weight": "400" }
                },
                [
                  _vm._v(
                    "\n        Se está cargando la información, espere unos segundos...\n      "
                  )
                ]
              )
            ]
          ),
          _c("v-progress-linear", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.cargando,
                expression: "cargando"
              }
            ],
            attrs: { indeterminate: "", color: "primary" }
          }),
          _c(
            "v-container",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.cargando,
                  expression: "!cargando"
                }
              ],
              staticClass: "my-9",
              attrs: { fluid: "", "grid-list-xl": "" }
            },
            [_c("Filtros")],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }